module.exports = __webpack_public_path__ + "img/landscape-3.1e79122e.png";